import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import CustomSelect from '../../../components/common/CustomSelect'
import toast from 'react-hot-toast'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  city: Yup.string().trim().required('City is required'),
  state: Yup.string().trim().required('State is required'),
  pincode: Yup.string().trim().required('Pincode is required'),
})

const Add = () => {
  const navigate = useNavigate()
  const [stateOptions, setStateOptions] = useState([])

  const fetchStateData = async () => {
    try {
      const response = await axiosAuthInstance.get('state/dropdown')
      if (response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: item.name,
        }))
        setStateOptions(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchStateData()
  }, [])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = axiosAuthInstance.post('city/add', {
        name: values.city,
        state: values.state,
        pincode: values.pincode,
      })
      if (response) {
        navigate('/city')
      }
    } catch (error) {
      console.log(error)
    }
  }
  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema: validationSchema,
    initialValues: {
      city: '',
      state: '',
      pincode: '',
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='city'
          label='City'
          placeholder='City'
          required
          component={CustomInput}
        />
        <Field
          name='state'
          label='State'
          placeholder='State'
          required
          component={CustomSelect}
          options={stateOptions}
        />

        <Field
          name='pincode'
          label='Pincode'
          placeholder='Pincode'
          required
          component={CustomInput}
          type='number'
        />
        <button
          type='submit'
          disabled={formik.isSubmitting}
          // onClick={addItem}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Add
        </button>
      </form>
    </FormikProvider>
  )
}

export default Add
